import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubTopic, SUBTOPIC_ACTIONS } from '../../_core/contact-our-experts.model';
import { FormContactComponent } from '../form-contact/form-contact.component';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Country } from '@spartacus/core';
import { Option } from '../../../../../../core/models/option.model';
import { RequestLoginComponent } from '../request-login/request-login.component';

@Component({
  selector: 'display-sub-content',
  standalone: true,
  imports: [CommonModule, FormContactComponent, RequestLoginComponent],
  templateUrl: './display-sub-content.component.html',
  styleUrl: './display-sub-content.component.scss',
})
export class DisplaySubContentComponent {
  SUBTOPIC_ACTIONS = SUBTOPIC_ACTIONS;

  @Input() subTopic!: SubTopic;
  @Input() form?: FormGroup;
  @Input() countries$: Observable<Country[]> = of([]);
  @Input() businessTypes$: Observable<Option[]> = of([]);
  @Input() stateRegions$: Observable<Option[]> = of([]);
  @Output() _onSubmit = new EventEmitter();

  submit() {
    this._onSubmit.emit();
  }
}
